import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { CommonDataPassService } from './app/common-resource/services/common-data-pass.service'

const loader = document.getElementById('app-init-loader');
bootstrapApplication(AppComponent, appConfig).then((appRef) => {
  const loaderService = appRef.injector.get(CommonDataPassService);
    loaderService.hide();
    loader?.remove();
}).catch((err) => console.error(err));
